"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRelativeTime = exports.getDatePlaceholder = exports.getDatePartsWithPlaceholders = exports.getStartDayOfTheWeek = exports.formatDateTimeToLocalISOString = exports.formatDateTimeToParts = exports.formatDateTime = exports.DateTimeFormatter = void 0;
const weekstart_1 = require("weekstart");
const DateTime_types_1 = require("./DateTime.types");
const DateTimeUtils_1 = require("./DateTimeUtils");
class DateTimeFormatter {
    constructor(dateTimeOptions) {
        this.formatter = (0, DateTimeUtils_1.getDateTimeFormatter)(dateTimeOptions);
    }
    formatDateTime(value) {
        return this.formatter.format(value);
    }
    formatDateTimeToParts(value) {
        return this.formatter.formatToParts(value);
    }
    formatDateTimeToLocalISOString(value) {
        var _a, _b, _c;
        const dateTimeOptions = this.formatter.resolvedOptions();
        const formatter = (0, DateTimeUtils_1.getDateTimeFormatter)({
            locale: dateTimeOptions.locale,
            timeZone: dateTimeOptions.timeZone,
            year: DateTime_types_1.Year.NUMERIC,
            month: DateTime_types_1.Month.TWO_DIGIT,
            day: DateTime_types_1.Day.TWO_DIGIT,
        });
        const parts = formatter.formatToParts(value);
        const year = (_a = parts.find((prop) => prop.type === "year")) === null || _a === void 0 ? void 0 : _a.value;
        const month = (_b = parts.find((prop) => prop.type === "month")) === null || _b === void 0 ? void 0 : _b.value;
        const day = (_c = parts.find((prop) => prop.type === "day")) === null || _c === void 0 ? void 0 : _c.value;
        return `${year}-${month}-${day}`;
    }
    getStartDayOfTheWeek() {
        return (0, weekstart_1.getWeekStartByLocale)(this.formatter.resolvedOptions().locale);
    }
    formatTimeDifference(rtf, difference) {
        const isFuture = difference >= 0 ? 1 : -1;
        difference = Math.abs(difference);
        const seconds = difference;
        if (seconds < 60) {
            return rtf.format(isFuture * seconds, "second");
        }
        const minutes = Math.round(seconds / 60);
        if (minutes < 60) {
            return rtf.format(minutes * isFuture, "minute");
        }
        const hours = Math.round(minutes / 60);
        if (hours < 24) {
            return rtf.format(hours * isFuture, "hour");
        }
        const days = Math.round(hours / 24);
        if (days < 7) {
            return rtf.format(days * isFuture, "day");
        }
        const weeks = Math.round(days / 7);
        if (weeks < 4.35) {
            return rtf.format(weeks * isFuture, "week");
        }
        const months = Math.round(weeks / 4.35);
        const quarters = Math.round(months / 4);
        if (months < 12) {
            if (quarters < 4) {
                return rtf.format(quarters * isFuture, "quarter");
            }
            return rtf.format(months * isFuture, "month");
        }
        const years = Math.round(months / 12);
        return rtf.format(years * isFuture, "year");
    }
    formatRelativeTime(relativeTimeOptions) {
        const locale = this.formatter.resolvedOptions().locale;
        const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
        if (!relativeTimeOptions.value && relativeTimeOptions.value !== 0) {
            throw new Error("Value is required");
        }
        if (typeof relativeTimeOptions.value === "number") {
            if (relativeTimeOptions.unit === undefined) {
                throw new Error("Unit is undefined.");
            }
            return rtf.format(relativeTimeOptions.value, relativeTimeOptions.unit);
        }
        const now = new Date();
        const date = new Date(relativeTimeOptions.value);
        if (isNaN(date.getTime())) {
            throw new Error("Invalid date");
        }
        const difference = (relativeTimeOptions.value.getTime() - now.getTime()) / 1000;
        return this.formatTimeDifference(rtf, difference);
    }
}
exports.DateTimeFormatter = DateTimeFormatter;
function formatDateTime(value, dateTimeOptions) {
    const formatter = new DateTimeFormatter(dateTimeOptions);
    return formatter.formatDateTime(value);
}
exports.formatDateTime = formatDateTime;
function formatDateTimeToParts(value, dateTimeOptions) {
    const formatter = new DateTimeFormatter(dateTimeOptions);
    return formatter.formatDateTimeToParts(value);
}
exports.formatDateTimeToParts = formatDateTimeToParts;
function formatDateTimeToLocalISOString(value, dateTimeOptions) {
    const formatter = new DateTimeFormatter(dateTimeOptions);
    return formatter.formatDateTimeToLocalISOString(value);
}
exports.formatDateTimeToLocalISOString = formatDateTimeToLocalISOString;
function getStartDayOfTheWeek(locale) {
    const formatter = new DateTimeFormatter({ locale });
    return formatter.getStartDayOfTheWeek();
}
exports.getStartDayOfTheWeek = getStartDayOfTheWeek;
function getDatePartsWithPlaceholders(locale, dateLabels) {
    const dateTimeOptions = {
        locale,
        year: DateTime_types_1.Year.NUMERIC,
        month: DateTime_types_1.Month.NUMERIC,
        day: DateTime_types_1.Day.NUMERIC,
    };
    const formatter = new DateTimeFormatter(dateTimeOptions);
    const parts = formatter.formatDateTimeToParts(Date.now());
    parts.forEach((part) => {
        switch (part.type) {
            case "month":
                part.value = dateLabels.month;
                break;
            case "day":
                part.value = dateLabels.day;
                break;
            case "year":
                part.value = dateLabels.year;
                break;
        }
    });
    return parts;
}
exports.getDatePartsWithPlaceholders = getDatePartsWithPlaceholders;
function getDatePlaceholder(locale, dateLabels) {
    const parts = getDatePartsWithPlaceholders(locale, dateLabels);
    return parts.reduce((acc, curr) => acc + curr.value, "");
}
exports.getDatePlaceholder = getDatePlaceholder;
function formatRelativeTime(locale, relativeTimeOptions) {
    const formatter = new DateTimeFormatter({ locale });
    return formatter.formatRelativeTime(relativeTimeOptions);
}
exports.formatRelativeTime = formatRelativeTime;
//# sourceMappingURL=DateTimeFormatter.js.map